import { useRef, useEffect } from 'react'

import styles from './infographic.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'


function Infographic(props) {
	const infographicRef = useRef(null)
	let fields = props.fields
	let accordionContent = props.accordionContent || false

	if(fields.custom_class == 'tumor_cell'){

		const tumorCellScroll = (topPos) => {
			const windowPos = window.scrollY
			const textElements = infographicRef.current.querySelectorAll(`.${styles.text}`)
			const lineElements = infographicRef.current.querySelectorAll(`.${styles.line}`)
			const containerHeight = infographicRef.current.parentNode.parentNode.offsetHeight
	
			if ((topPos <= windowPos) && !textElements[textElements.length - 1].classList.contains(styles.visible)) {
				infographicRef.current.parentNode.parentNode.style.position = 'sticky'
			}

			textElements.forEach(function(element, index) {
				if (((containerHeight/4) * index) <= (windowPos - topPos)) {
					if(index >= textElements.length - 1 && !textElements[textElements.length - 1].classList.contains(styles.visible)){
						window.scroll(0, topPos)
						infographicRef.current.parentNode.parentNode.style.marginBottom = 'auto'
						infographicRef.current.parentNode.parentNode.style.position = 'relative'
					}

					element.classList.add(styles.visible)
					lineElements[index].classList.add(styles.visible)
				}
			})
		}


		useEffect(() => {
			setTimeout(() => {
				const topPos = infographicRef.current.parentNode.parentNode.offsetTop + 100
				window.addEventListener('scroll', () => {tumorCellScroll(topPos)})
			}, 500)

			return () => window.removeEventListener('scroll', tumorCellScroll)
		}, [])
	}

	return <BlockWrapper {...props} fullbleed={props.accordionContent ? false : true} className={classNames(styles.infographic, styles[fields.custom_class], accordionContent ? styles.accordion_content : '', fields.hide_borders ? styles.no_border : '')}>
		<ScrollAnimation styles={styles}>

			<div ref={infographicRef} className={styles.infographic_wrapper}>
				{fields.image && <Image {...fields.image} alt="Infographic" className={styles.image} />}

				{fields.custom_class == 'tumor_cell' &&
					<div>
						<div className={styles.line_container}>
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/RepertoireID_line.svg`}} alt="Infographic" className={styles.line} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/NeoantigenID_line.svg`}} alt="Infographic" className={styles.line} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/ImmunogenomicsID_line.svg`}} alt="Infographic" className={styles.line} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/InfiltrateID_line.svg`}} alt="Infographic" className={styles.line} />
						</div>
						<div className={styles.text_container}>
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/RepertoireID.svg`}} alt="Infographic" className={styles.text} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/NeoantigenID.svg`}} alt="Infographic" className={styles.text} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/ImmunogenomicsID.svg`}} alt="Infographic" className={styles.text} />
							<Image {...{url: `/wp-content/themes/personalis/assets/infographics/tumor_cell/InfiltrateID.svg`}} alt="Infographic" className={styles.text} />
						</div>
					</div>
				}
			</div>

			{(fields.caption.prefix || fields.caption.title || fields.caption.content) &&
				<div className={styles.caption}>
					<div className={styles.caption_wrapper}>
						<p>
							{fields.caption.prefix &&
								<span className={styles.prefix}>{fields.caption.prefix}
								{fields.caption.title &&
									`: ` 
								}
								</span>
							}
							{fields.caption.title &&
								<span className={styles.title}>{fields.caption.title}</span>
							}
						</p>
						{fields.caption.content &&
							<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.caption.content}} />
						}
					</div>
				</div>
			}
		</ScrollAnimation>
	</BlockWrapper>
}

export default Infographic